import { forwardRef } from 'react';
import { CheckCircle2, Loader2, RotateCw } from 'lucide-react';
import { when } from '@/components/invoices/invoiceFormat';

const OVERLINE = 'text-[10px] font-semibold uppercase tracking-[0.16em] text-[#5C6370]';

function Note({ p, v, onReload }) {
  if (p.note?.tone === 'ok') {
    return (
      <p className="flex items-start gap-2 rounded-sm bg-[#E8F0EA] px-3 py-2.5 text-sm text-[#2F5D3E]" data-testid="proposal-submit-ok">
        <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" />Thank you, {v.submitted?.name}. {v.company.name} has your picks and will send your proposal to sign, built from them.
      </p>
    );
  }
  if (p.note?.tone === 'error') {
    return (
      <p className="text-sm text-[#B45353]" data-testid="proposal-submit-error">{p.note.text}
        {p.note.reload && <button type="button" onClick={onReload} className="ml-2 inline-flex items-center gap-1 font-semibold text-[#4575A8]" data-testid="proposal-reload"><RotateCw className="h-3.5 w-3.5" />Reload</button>}
      </p>
    );
  }
  return null;
}

// Who's sending the picks, and the send button (on phones the pinned bar has it). After a send, it reads "Update".
const SubmitBox = forwardRef(function SubmitBox({ v, p, name, setName, needName, label, preview, onSubmit, color }, ref) {
  return (
    <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }} className="mt-6 space-y-3 rounded-md border border-[#D5D8DD] bg-[#F7F8FA] p-4 sm:p-5" data-testid="proposal-submit-box">
      {v.submitted && p.note?.tone !== 'ok' && (
        <p className="text-xs text-[#4A7C59]" data-testid="proposal-submitted">{v.submitted.name} sent picks on {when(v.submitted.at)}. You can change them until your proposal is sent for signing.</p>
      )}
      <label className="block space-y-1"><span className={OVERLINE}>Your name</span>
        <input ref={ref} value={name} onChange={(e) => setName(e.target.value)} maxLength={120} autoComplete="name" placeholder="First and last name"
          className={`h-12 w-full rounded-md border bg-white px-3 text-base text-[#0D1B2A] outline-none transition-colors focus:border-[#4575A8] focus:ring-2 focus:ring-[#4575A8]/20 ${needName ? 'border-[#B45353]' : 'border-[#C3C8D0]'}`}
          data-testid="proposal-name" /></label>
      {needName && <p className="text-xs text-[#B45353]" data-testid="proposal-name-needed">Enter your name to send your picks.</p>}
      <Note p={p} v={v} onReload={p.load} />
      <button type="submit" disabled={p.sending || preview}
        title={preview ? 'Preview: the client sends their picks here.' : undefined}
        className="hidden h-12 w-full items-center justify-center gap-2 rounded-md text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-50 sm:inline-flex"
        style={{ background: color }} data-testid="proposal-submit">
        {p.sending && <Loader2 className="h-4 w-4 animate-spin" />}{label}
      </button>
    </form>
  );
});

export default SubmitBox;
